import { Radio } from "@mui/material";
import { CharacteristicWrapper, OptionChip, RadiosShell } from "./styles";

interface IProps {
  label: string;
  radioGroupName: string;
  checked: boolean;
  onChange: (value: boolean) => void;
}

function RadioOption({ label, radioGroupName, checked, onChange }: IProps) {
  return (
    <CharacteristicWrapper>
      <p>{label}</p>

      <RadiosShell>
        <OptionChip $active={checked} onClick={() => onChange(true)}>
          <Radio
            disableRipple
            size="small"
            name={radioGroupName}
            checked={checked}
            onChange={() => onChange(true)}
          />
          <p>Sim</p>
        </OptionChip>
        <OptionChip $active={!checked} onClick={() => onChange(false)}>
          <Radio
            disableRipple
            size="small"
            name={radioGroupName}
            checked={!checked}
            onChange={() => onChange(false)}
          />
          <p>Não</p>
        </OptionChip>
      </RadiosShell>
    </CharacteristicWrapper>
  );
}

export default RadioOption;
